import { Server, UrlAPI } from '../enums/index.js';
import { ExceptionType } from '@/plugins/enums/index.js';
import { get as getItemLocal, localStorageKey } from '@/plugins/localStorage/index.js';
import axios from 'axios';

const axiosConfig = {
    baseURL: Server.url,
    headers: {
        'Content-Type': 'application/json'
    }
};

const api = axios.create(axiosConfig);
const allowAnonymousApi = axios.create(axiosConfig);

// Server will always return a response with a status 200 and a message even if there was an error
const onRequestFullfilled = (result) => {
    const resultData = result.data;

    if (!resultData.isError) {
        return resultData
    }

    let message;
    switch (resultData.nameError) {
        case ExceptionType.LogicalException:
            message = resultData.message;
            break;
        case ExceptionType.TechnicalException:
            message = `Error en el servidor: ${resultData.message.substring(0, 100)}`;
            break;
        default:
            message = 'Error no proyectado en la aplicación, informe al administrador';
    }

    return {
        message,
        isError: true,
        data: {}
    };
};

const onRequestRejected = (error) => {
    let message;
    if (!error.response) {
        message = `Error al comunicarse con el servidor ${error.message.substring(0, 100)}`;
    } else if (error.response.status === 400) {
        message = `Error en los datos enviados: ${JSON.stringify(error.response.data.title).substring(0, 100)}`;
    } else {
        message = `Error inesperado: ${error.message.substring(0, 100)}`;
    }

    return {
        message,
        isError: true,
        data: {}
    };
};

const attachAuthToken = (config) => {
    if (config.headers.Authorization) return config;

    const token = getItemLocal(localStorageKey.tokenKey);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
};

const attachAnonymousToken = async (config) => {
    if (config.headers.Authorization) return config;

    try {
        const result = await api.get(UrlAPI.generateShortLivedToken);

        if (result.isError) {
            return Promise.reject(result);
        }

        config.headers.Authorization = `Bearer ${result.data}`;
        return config;
    } catch (error) {
        return Promise.reject(error);
    }
};

api.interceptors.request.use(attachAuthToken);
api.interceptors.response.use(onRequestFullfilled, onRequestRejected);

allowAnonymousApi.interceptors.request.use(attachAnonymousToken);
allowAnonymousApi.interceptors.request.use(attachAuthToken);
allowAnonymousApi.interceptors.response.use(onRequestFullfilled, onRequestRejected);

const createFormData = (data) => {
    const formData = new FormData();
    formData.append('file', data);
    return formData;
};

const formDataConfig = {
    headers: { 'Content-Type': 'multipart/form-data' }
};

export const apiClient = {
    get: (endpoint, data) => api.get(endpoint, {
        params: data,
        paramsSerializer: { indexes: null }
    }),
    post: api.post,
    put: api.put,
    putFormData: (endpoint, data) =>
        api.put(endpoint, createFormData(data), formDataConfig)
};

export const allowAnonymousClient = {
    get: (endpoint, data) => allowAnonymousApi.get(endpoint, {
        params: data,
        paramsSerializer: { indexes: null }
    }),
    post: allowAnonymousApi.post,
    put: allowAnonymousApi.put,
    putFormData: (endpoint, data) =>
        allowAnonymousApi.put(endpoint, createFormData(data), formDataConfig)
};
